<button class="client-name" [name]="client.name" (click)="clientClick.emit(client.id)">
  <img [src]="imageURI" [alt]="client.name" />
</button>
